import React from 'react';
import { arrowBack, closeOutline } from 'ionicons/icons';
import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/react';

const TakerModalHeader = ({ pageName, onXButton = () => null, showBackButton = false, onBack }) => {
  return (
    <IonHeader className='taker-modal-header ion-no-border'>
      <IonToolbar className='taker-modal-toolbar'>
        <IonButtons slot='start'>
          {showBackButton && (
            <IonButton fill='clear' className='back-arrow' onClick={onBack}>
              <IonIcon icon={arrowBack} />
            </IonButton>
          )}
        </IonButtons>
        <IonTitle className='taker-modal-title'>{pageName}</IonTitle>
        <IonButtons slot='end'>
          <IonButton onClick={onXButton}>
            <IonIcon icon={closeOutline} slot='icon-only' />
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default TakerModalHeader;
